import "./Hero.css";
import Fade from "react-reveal/Fade";
import Zoom from "react-reveal/Zoom";
import icon1 from "../assets/img/icon-1.png";
import icon2 from "../assets/img/icon-2.png";
import icon3 from "../assets/img/icon-3.png";

const Hero = () => {
  return (
    <section className="hero" id="hero">
      <div className="hero-top">
        <Zoom>
          <div className="welcome-note">
            <div>
              <h1>
                We provide an <span className="span-1">Innovative</span>,{" "}
                <span className="span-2">Flexible Education</span> tailored to
                nurture your child's <span className="span-1">Talents</span> and{" "}
                <span className="span-1">Academic</span> success, guided by the{" "}
                <span className="span-2">
                  Cambridge International Curriculum
                </span>
                .
              </h1>
            </div>
            <a
              to={"/therapists"}
              className="join-wellingtonia"
              href="https://forms.gle/UE7YqR5ni6XUtzip9"
              target={"_blank"}
              rel="noreferrer"
            >
              Join Wellingtonia
            </a>
          </div>
        </Zoom>
      </div>
      <div className="hero-footer">
        <Fade left>
          <div className="hero-card" style={{ backgroundColor: "#e0b15dbf" }}>
            <div className="hero-card-header">
              <div className="icon-div" style={{ backgroundColor: "#e6e7e8" }}>
                <img src={icon1} alt="Affordable" />
              </div>
              <h3>Personalized Learning Paths</h3>
            </div>
            <p style={{ color: "#fff", marginTop: 20 }}>
              We tailor education to your child’s strengths, fostering
              personalized growth in both academics and passions.
            </p>
          </div>
        </Fade>
        <Zoom>
          <div className="hero-card" style={{ backgroundColor: "#000000bf" }}>
            <div className="hero-card-header">
              <div className="icon-div" style={{ backgroundColor: "#e6e7e8" }}>
                <img src={icon2} alt="Convenient" />
              </div>
              <h3>Flexible and Modern Learning</h3>
            </div>
            <p style={{ color: "#fff", marginTop: 20 }}>
              Our blended model offers virtual and Home learning options,
              adapting to your family's needs and lifestyle.
            </p>
          </div>
        </Zoom>
        <Fade right>
          <div className="hero-card" style={{ backgroundColor: "#ffffffbf" }}>
            <div className="hero-card-header">
              <div className="icon-div" style={{ backgroundColor: "#e6e7e8" }}>
                <img src={icon3} alt="You - Centered" />
              </div>
              <h3 style={{ color: "#000" }}>Holistic Development</h3>
            </div>
            <p style={{ color: "#000", marginTop: 20 }}>
              We develop well-rounded individuals, focusing on creativity,
              emotional intelligence, and leadership beyond traditional
              academics.
            </p>
          </div>
        </Fade>
      </div>
    </section>
  );
};

export default Hero;
